export enum ContractDemandDataGridField {
  PRIORITY = 'priority',
  SEQUENCE_NUMBER = 'sequenceNumber',
  DESCRIPTION = 'description',
  COMMODITY_GROUP_ID = 'commodityGroupId',
  RESPONSIBLE_USER_ID = 'responsibleUserId',
  TAG_IDS = 'tagIds',
  CREATED_AT = 'createdAt',
  VALID_FROM = 'validFrom',
  VALID_TO = 'validTo',
  STATUS = 'status',
  TOTAL_VALUE = 'totalValue',
  TOTAL_CASE_COUNT = 'totalCaseCount',
  NEGOTIATED_CASE_COUNT = 'negotiatedCaseCount',
  OPEN_CASE_COUNT = 'openCaseCount',
  QUALIFIED_SUPPLIER_IDS = 'qualifiedSupplierIds',
}
